import { Card, message, theme } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  Permission,
  type CreateCatalogCategoryDto,
  type UpdateCatalogCategoryDto,
} from '@aid/shared';
import { useHasPermission } from '../../auth/useHasPermission';
import { PageHeader } from '../../components/PageHeader';
import { useCreateCategoriaAdmin } from './api/useCatalogosAdmin';
import { CatalogCategoryForm } from './components/CatalogCategoryForm';

export function CatalogCategoryCreatePage() {
  const navigate = useNavigate();
  const createCategory = useCreateCategoriaAdmin();
  const hasPermission = useHasPermission(Permission.CATALOGOS_CREATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tenés permiso para crear categorías.</div>;
  }

  const handleSubmit = async (values: CreateCatalogCategoryDto | UpdateCatalogCategoryDto) => {
    if (!('code' in values)) return;
    try {
      await createCategory.mutateAsync(values);
      message.success('Categoría creada correctamente');
      navigate(`/catalogos/category/${encodeURIComponent(values.code)}`);
    } catch {
      message.error('No se pudo crear la categoría');
    }
  };

  return (
    <div>
      <PageHeader title="Nueva categoría" subtitle="Definí cómo se comportará un nuevo catálogo." />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <CatalogCategoryForm
          mode="create"
          onSubmit={handleSubmit}
          loading={createCategory.isPending}
        />
      </Card>
    </div>
  );
}
